import { z } from 'zod';

import { PASSWORD_MIN_LENGTH } from '@/shared/constants';
import type { TranslateFn } from '@/shared/types';

export function passwordField(t: TranslateFn): z.ZodString {
    return z
        .string()
        .min(PASSWORD_MIN_LENGTH, t('validation.password.min-length', { length: PASSWORD_MIN_LENGTH }))
        .regex(/[0-9]/, t('validation.password.numbers-required'))
        .regex(/[a-zA-Z]/, t('validation.password.letters-required'));
}
